import { DomainSummary } from 'data/models/DomainSummary';
import { Navbar } from 'portcall/navbar/model';
import { AjaxErrors } from 'core/ajaxerrors/model';
import { UIThemeSetter } from 'portcall/uithemesetter/model';

export type AppWrapper = ReturnType<typeof AppWrapper>;
export function AppWrapper(navbar: Navbar, ajaxErrors: AjaxErrors, domainSummary: DomainSummary, UITheme : UIThemeSetter) {
    return {
        Navbar: navbar,
        AjaxErrors: ajaxErrors,
        DomainSummary: domainSummary,
        UITheme
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/appwrapper/model.ts